import { useTranslations } from 'next-intl';
import { getRecupTagFromTags } from '../../utils';

export const useFormatAntiWasteTag = (tags: string[] = []) => {
  const tCatalog = useTranslations('Catalog');
  const tag = getRecupTagFromTags(tags);

  if (!tag) {
    return undefined;
  }

  return tCatalog(
    tag.translationKey as 'tagAntiwaste' | 'tagMinimumDurabilityDate',
    tag.date ? { date: tag.date } : undefined,
  );
};
